import {InvoicePaymentSearchComponent} from './invoice-payment-search.component';

export const InvoicePaymentRoutes = [
  {
    path: 'invoice-payment-search',
    component: InvoicePaymentSearchComponent,
  },
];
